import { useState, useEffect, createContext, useContext } from 'react';
import { translations, getTranslation } from './translations.js';

// Create Language Context
const LanguageContext = createContext();

// Language Provider Component
export const LanguageProvider = ({ children }) => {
  // Get initial language from localStorage or default to Spanish
  const getInitialLanguage = () => {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem('pld-language');
      if (saved && ['en', 'es'].includes(saved)) {
        return saved;
      }
    }
    return 'es';
  };

  const [currentLanguage, setCurrentLanguage] = useState(getInitialLanguage);

  // Save language preference to localStorage
  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('pld-language', currentLanguage);
    }
  }, [currentLanguage]);

  const changeLanguage = (languageCode) => {
    if (['en', 'es'].includes(languageCode)) {
      setCurrentLanguage(languageCode);
    }
  };

  const t = (key, variables = {}) => {
    return getTranslation(translations[currentLanguage], key, variables);
  };

  const value = {
    currentLanguage,
    changeLanguage,
    t,
    isEnglish: currentLanguage === 'en',
    isSpanish: currentLanguage === 'es'
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

// Custom hook to use language context
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};